<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190329-feature-twins.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">双胞胎儿竟然是同母异父</div>
                   <div class="post_info">Posted at 09:00h in 亲子鉴定</div>
                    <div class="post_tip_1" style="margin-top:0px !important;">
                       福建厦门一名女子诞下同母异父双胞胎，成为了她出轨的证明。
                    </div>
                    <div class="post_wrapper_1">
                       纸永远不能包着火，事实总是会公诸于世！福建省厦门市一对夫妻因为要帮双胞胎儿子报户口，所以去做亲子鉴定，没想到结果显示，双胞胎竟是「同母异父」兄弟！丈夫没想过双胞胎儿子当中有一个不是他亲生的，愤怒逼问下，妻子才不得不承认曾和其他男人发生过“一夜情”。
                    </div>
                  
                    <div class="post_wrapper_tip">专家：百万分之一机会</div>
                    <div class="post_wrapper_1">
                        根据专家指出，一对双胞胎有两个父亲的情况，发生的机会只有百万分之一，比起中彩票还要难！
                    </div>
                    <div class="post_wrapper_1 margin_top">
                        正常女性的排卵是一个月排一颗卵子，但有些女性很罕见地会一个月排两颗卵子。如果女性在排卵期有两颗卵子排出，又在排卵期内跟不同男子发生性关系，那么两颗卵子便有可能与两个不同男子的精子受精，出现单次怀上同母异父双胞胎的情况，不过这种情况真的只有百万分之一机会才会出现。
                    </div>

                    <div class="post_wrapper_tip">产前亲子鉴定</div>
                    <div class="post_wrapper_tip_c"><strong>技术原理</strong></div>
                    <div class="post_wrapper_2">
                       在妈妈怀孕时，胎儿的DNA会经胎盘进入妈妈的血液。从母体静脉血中可以分离得到胎儿的DNA，将受测胎儿的DNA和假定父亲的DNA作分析和比较，鉴定他们之间的其中一半DNA是否相同，从而计算出他们之间的亲子机率。
                    </div>
                    <div class="post_wrapper_tip_c"><strong>检测条件</strong></div>
                    <div class="post_wrapper_2">
                       怀孕7周即可抽血检测，只需采集孕妇10ml 静脉血和假定父亲的相关检验样本 (血液、口腔细胞、指甲、含毛囊的毛发等) 。 8-12个工作日有结果。准确率达99.99%以上。
                    </div>
                     <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190329-paternity-embryo.jpg"/>
                        <div class="bottom_tip">福建省厦门市一对夫妻因为要帮双胞胎儿子报户口，所以去做亲子鉴定，没想到结果显示，双胞胎竟是「同母异父」兄弟！</div>
                    </div>

                     <div class="post_wrapper_tip">已出生亲子鉴定</div>
                    <div class="post_wrapper_tip_c"><strong>技术原理</strong></div>
                    <div class="post_wrapper_2">
                       测试需要抽取受测孩子和假定父亲血液相关检验样本，然后从样本中分离出二人的DNA再作分析和比较，而确定他们之间的其中一半DNA是否相同，从而计算出父系亲子机率。
                    </div>
                    <div class="post_wrapper_tip_c"><strong>检测条件</strong></div>
                    <div class="post_wrapper_2">
                      收集父亲或母亲和受测孩子血液、口腔细胞、含毛囊的毛发或指甲等都可以做亲子鉴定。3-5个工作日有结果。准确率达99.99%以上。
                    </div>
                     <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190329-paternity-child.jpg"/>
                        <div class="bottom_tip">福建省厦门市一对夫妻因为要帮双胞胎儿子报户口，所以去做亲子鉴定，没想到结果显示，双胞胎竟是「同母异父」兄弟！</div>
                    </div>

                    
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_2{
                     margin-top:3px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_tip_c{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    margin-top:10px;
                    letter-spacing: .07em!important;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensfive.vue